module.exports = __webpack_public_path__ + "img/pink-gem-3.8729fcb2.png";